<template>
  <v-dialog
    class="text-left"
    v-model="isOpenDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="fixed-bar" dark flat color="primary">
        <v-btn icon dark @click="closeDialog()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Product Information</v-toolbar-title>
      </v-toolbar>

      <v-skeleton-loader
        v-if="!isLoaded"
        type="image,list-item, divider, list-item, divider,list-item,divider,list-item,divider"
      ></v-skeleton-loader>

      <v-container v-if="isLoaded" class="pa-0">
        <v-img
          lazy-src="https://erp.happenstance.com/images/default.jpg"
          :src="sku.image"
          alt=""
          max-height="250px"
        />
      </v-container>

      <v-container v-if="isLoaded">
        <v-row class="grey lighten-3">
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 h6">{{ sku.product.name }}</h3>
            <h3 class="grey--text text--darken-2 caption">
              {{ sku.sku_name }}
            </h3>
          </v-col>
          <v-col cols="4" class="text-right">
            <span class="caption grey--text text-lighten-2">MRP</span>
            <h3 class="primary--text h6 pa-0">₹ {{ sku.mrp }}</h3>
          </v-col>
        </v-row>

        <v-row class="mb-0">
          <v-col cols="3">
            <h3 class="grey--text body-2">Model</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 body-2">
              {{ sku.sku_name }}
            </h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0">
          <v-col cols="3">
            <h3 class="grey--text body-2">Barcode</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 body-2">{{ sku.barcode }}</h3>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-0">
          <v-col cols="3">
            <h3 class="grey--text body-2">Sku Code</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 body-2">{{ sku.sku_code }}</h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0">
          <v-col cols="3">
            <h3 class="grey--text body-2">Size</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 body-2">
              {{ sku.size.size }}
            </h3>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-0">
          <v-col cols="3">
            <h3 class="grey--text body-2">Color</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 body-2">
              {{ sku.colour.colour }}
            </h3>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-0">
          <v-col cols="3">
            <h3 class="grey--text body-2">MRP</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 body-2">₹ {{ sku.mrp }}</h3>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-snackbar v-model="snackbar" color="error" timeout="1500"
      >{{ snackbar_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog", "id"],
  data() {
    return {
      snackbar: false,
      snackbar_message: "Internal Server Error",
      sku: {},
      isLoaded: false,
    };
  },
  computed: {
    isOpenDialog() {
      return this.dialog;
    },
  },
  watch: {
    isOpenDialog(isOpen) {
      if (isOpen) {
        this.$api.getSkuDetails({ id: this.id }).then(
          (response) => {
            if (response.data.status == "success") {
              this.sku = response.data.sku;
              this.isLoaded = true;
            }
          },
          (error) => {
            console.log(error);
            this.snackbar = true;
            this.isLoading = false;
            this.isLoaded = true;
          }
        );
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>

<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0px;
  z-index: 2;
  border-radius: 0 !important;
}
.row {
  border-bottom: solid 1px #f1f1f1;
}
</style>
